import styled from 'styled-components';
import device from '../../mediaQueries';

const BottomText = styled.div`
  align-items: center;
  display: flex;
  margin: 0 auto;
  max-width: 500px;
  text-align: center;
  justify-content: center;
  align-items: baseline;
  height: 15px;
  color: #fff;

  ${device.desktop`
    margin: ${({ margin }) => margin};
  `}

  ${device.mobile`
    height: 30px;
  `}
`;

export default BottomText;
